// Email draft card (EmailDraftCard)
// (WEB-8005). Composed by praxisStyles.ts at the section's original
// position — source order is part of the cascade.
export const praxisEmailDraft = `
/* Email draft — full-bordered card so a standalone email proposal reads as
 * a self-contained card (matching grouped write proposals). */
.pr-email-card-wrapper { margin: 12px 0; }
.pr-email-card-wrapper > .ws-prop-card {
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  overflow: hidden;
}
.pr-email-card-wrapper > .ws-prop-card--expanded { background: var(--ws-panel); }

/* Email draft body — DT/DD label grid, with matching subject/message inputs */
.pr-email-body { font-size: 13px; }
.pr-email-error {
  margin-bottom: 10px;
  padding: 8px 10px;
  border-radius: 4px;
  background: rgba(178, 52, 52, 0.08);
  color: var(--ws-err, #b23434);
  font-size: 12.5px;
}
.pr-email-fields {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 8px 14px;
  margin: 0;
  align-items: center;
}
.pr-email-fields dt {
  font-family: var(--pr-font-mono);
  font-size: 10.5px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--pr-ink-4);
  font-weight: 500;
}
.pr-email-fields dd {
  margin: 0;
  color: var(--pr-ink);
  min-width: 0;
}
/* The textarea row is much taller than its label — pin the label to the
 * first line of the textarea instead of vertically centring it. */
.pr-email-fields .pr-email-label-multiline { align-self: start; padding-top: 7px; }
.pr-email-input {
  width: 100%;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  padding: 5px 9px;
  font-family: var(--ws-sans);
  font-size: 13px;
  color: var(--ws-ink);
  background: var(--ws-panel);
  line-height: 1.45;
}
.pr-email-input:focus {
  outline: none;
  border-color: var(--ws-ink-3);
}
.pr-email-input:disabled {
  background: var(--ws-bg);
  opacity: 0.7;
  cursor: not-allowed;
}
.pr-email-textarea {
  resize: vertical;
  min-height: 96px;
  padding: 7px 9px;
}
/* The rep's signature, rendered as it will be sent — read-only, so it reads as
 * a preview rather than another input. Signatures are laid out with wide
 * tables and full-size logos, so cap both axes and let the block scroll. */
.pr-email-signature {
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  padding: 7px 9px;
  background: var(--ws-bg);
  color: var(--ws-ink);
  font-size: 12.5px;
  max-height: 180px;
  overflow: auto;
}
.pr-email-signature img { max-width: 100%; height: auto; }
.pr-email-signature table { max-width: 100%; }
/* Inert links. The card holds the rep's unsent subject/body in component state,
 * so a signature link — the privacy-policy one every signature carries, say —
 * would navigate the whole SPA away and take those edits with it. Scrolling and
 * selection stay live; only the click is dropped. */
.pr-email-signature a { pointer-events: none; cursor: default; }
.pr-email-attachments {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.pr-email-attachments li {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--ws-text-muted, #6b7280);
}
.pr-wgroup-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.pr-wgroup-item {
  border-bottom: 1px solid var(--pr-hairline);
}
.pr-wgroup-item:last-child { border-bottom: none; }
.pr-wgroup-row {
  width: 100%;
  display: flex; align-items: center; gap: 10px;
  padding: 9px 14px;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
  font-size: 13px;
  color: var(--pr-ink);
  transition: background 120ms ease;
}
.pr-wgroup-row:hover { background: var(--pr-surface-2); }
.pr-wgroup-item.is-open .pr-wgroup-row { background: var(--pr-surface-2); }
.pr-wgroup-chev { color: var(--pr-ink-4); flex-shrink: 0; }
.pr-wgroup-icon { color: var(--pr-ink-4); flex-shrink: 0; }
.pr-wgroup-ident {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--pr-ink-2);
}
.pr-wgroup-pill {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: 10.5px;
  letter-spacing: 0.04em;
  padding: 2px 8px;
  border-radius: 999px;
  font-family: var(--pr-font-mono);
  font-weight: 500;
  flex-shrink: 0;
}
.pr-wgroup-pill--pending { background: var(--pr-surface); color: var(--pr-ink-3); border: 1px solid var(--pr-hairline); }
.pr-wgroup-pill--ok { background: var(--pr-success-soft); color: oklch(0.32 0.10 155); }
.pr-wgroup-pill--muted { background: var(--pr-surface); color: var(--pr-ink-4); border: 1px solid var(--pr-hairline); }
.pr-wgroup-pill--error { background: var(--pr-danger-soft); color: oklch(0.38 0.16 25); }
.pr-wgroup-body {
  padding: 6px 14px 12px;
  background: var(--pr-surface-2);
  border-top: 1px dotted var(--pr-hairline);
}
.pr-wgroup-body .pr-wcard { margin-left: 0; }
.pr-wgroup-body .pr-action-card { margin: 0; box-shadow: none; }
`;
